<template>
  <div class="page-add">
    <template v-if="!isLoading">
      <header class="page-header">
        <h2 class="tit-h2">
          리퀘스트 수정 - {{  requestStore.request?.customer.companyName }}
        </h2>
        <div class="btn-group">
          <el-button
            type="primary"
            size="large"
            aria-label="이전으로"
            class="btn-icon"
            @click="toBack"
          >
            <font-awesome-icon icon="fa-solid fa-arrow-left-long" />
          </el-button>
        </div>
      </header>
      <el-form
        :model="form"
        label-position="left"
        label-width="100px"
        class="content-box"
        >
        <section class="section">
          <h3 class="tit-h3">
            고객 정보
          </h3>
          <el-form-item label="뷰저블 계정">
            <el-input
              v-model="form.customerId"
              disabled
              size="large"
              style="width: 300px"
            />
          </el-form-item>
        </section>
        <section class="section">
          <h3 class="tit-h3">
            요청 상세 정보
          </h3>
          <el-form-item label="요청 유형">
            <el-select
              v-model="form.requestType"
              disabled
              placeholder="선택하세요."
              size="large"
              style="width: 170px"
              @change="updateRequestDatails"
            >
              <el-option
                v-for="item in optionsReqType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="히트맵 플랜"
            v-show="form.requestType === 'PLAN'"
          >
            <el-select
              v-model="form.beusPlanNumber"
              placeholder="선택하세요."
              size="large"
              style="width: 240px"
              ref="beusPlanInput"
            >
              <el-option
                :key="-1"
                label="Not applicable"
                :value="-1"
              />
              <el-option-group
                v-for="group in optionsPlan.beus"
                :key="group.planGroup"
                :label="group.planGroup"
              >
                <el-option
                  v-for="plan in group.plans"
                  :key="plan._id"
                  :label="plan.planName"
                  :value="plan.planNumber"
                />
              </el-option-group>
            </el-select>
            <el-text type="danger">
              <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
              변경이 필요한지 확인하세요<div class=""></div>
            </el-text>
          </el-form-item>
          <el-form-item 
            label="저니맵 플랜"
            v-show="form.requestType === 'PLAN'"
          >
            <el-select
              v-model="form.baPlanNumber"
              placeholder="선택하세요."
              size="large"
              style="width: 240px"
            >
              <el-option
                :key="-1"
                label="Not applicable"
                :value="-1"
              />
              <el-option-group
                v-for="group in optionsPlan.ba"
                :key="group.planGroup"
                :label="group.planGroup"
              >
                <el-option
                  v-for="plan in group.plans"
                  :key="plan._id"
                  :label="plan.planName"
                  :value="plan.planNumber"
                />
              </el-option-group>
            </el-select>
            <el-text type="danger">
              <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
              변경이 필요한지 확인하세요.
            </el-text>
          </el-form-item>
          <el-form-item
            label="사용 시작일"
            v-if="form.requestType"
          >
            <el-date-picker
              v-model="form.useStartDate"
              type="date"
              placeholder="선택하세요"
              size="large"
              style="width: 170px"
              :clearable="false"
              :disabled-date="disablePastDates"
            />
            <el-text 
              type="danger" 
              v-if="dateRangeError"
            >
              <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
              시작일이 종료일 이후 일 수 없습니다.
            </el-text>
          </el-form-item>
          <el-form-item
            label="계약 개월 수"
            v-show="form.requestType === 'PLAN' || form.requestType === 'ADDITIONAL'"
            >
            <el-input
              v-model="form.period"
              size="large"
              style="width: 60px"
              class="input-period"
              ref="periodInput"
            />
            <el-text type="danger">
              <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
              변경이 필요한지 확인하세요.
            </el-text>
          </el-form-item>
          <el-form-item
            label="사용 종료일"
            v-show="form.period"
          >
            <el-date-picker
              v-model="form.useEndDate"
              :disabled="form.requestType !== 'PV_CHARGE'"
              type="date"
              size="large"
              style="width: 170px"
              :disabled-date="setPlanDisabledDate"
            />
          </el-form-item>
          <el-form-item
            label="자동 갱신 여부"
            v-show="form.requestType === 'PLAN' || form.requestType === 'PV_CHARGE' || form.requestType === 'JAM_CHARGE'"
          >
            <el-radio-group v-model="form.recurring">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </section>
        <section class="section">
          <h3 class="tit-h3">
            결제 정보
          </h3>
          <el-form-item label="제공 방식">
            <el-radio-group v-model="chargeType">
              <el-radio 
                value="charged" 
                @change="handleChargeType"
              >
                유상
              </el-radio>
              <el-radio 
                value="free"
                @change="handleChargeType"
              >
                무상
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="chargeType === 'charged'">
            <el-form-item label="결제 방식">
              <el-radio-group v-model="form.paymentType">
                <el-radio 
                  value="wire" 
                  @change="handleChargePaymentType"
                >
                  무통장
                </el-radio>
                <el-radio 
                  value="card"
                  @change="handleChargePaymentType"
                >
                  카드
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item 
              label="결제 주기"
              v-show="form.period && form.requestType === 'PLAN' && Number(form.period) > 1"
            >
              <el-select
                v-model="form.paymentCycle"
                size="large"
                style="width: 170px"
                placeholder="선택하세요."
              >
                <el-option
                  v-for="item in optionsPaymentCycle"
                  :key="item"
                :label="paymentCycleLabels[item]"
                :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="결제 금액">
              <el-input
                v-model="form.amount"
                :formatter="(value: string) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value: string) => value.replace(/\$\s?|(,*)/g, '')"
                size="large"
                style="width: 170px"
                class="input-price"
                ref="amountInput"
              >
                <template #append>
                  원
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="결제일">
              <el-date-picker
                v-model="form.paymentDate"
                type="date"
                placeholder="선택하세요"
                size="large"
                style="width: 170px"
                :clearable="false"
                :disabled-date="disablePastDates"
              />
              <el-checkbox
                v-if="form.isEndOfMonth || form.paymentCycle !== '0'"
                :disabled="!isEndOfMonthEnabled(form.paymentDate)"
                v-model="form.isEndOfMonth"
              >
                해당 월 마지막 날짜에 결제
              </el-checkbox>
            </el-form-item>
            <el-form-item label="서류 발행">
              <div 
                class="document-row" 
                v-for="(doc, index) in form.docs" 
                :key="index"
              >
                <div class="document-col">
                  <el-select
                    v-model="doc.docType"
                    placeholder="서류 유형"
                    size="large"
                    style="width: 120px"
                    >
                    <el-option
                      v-for="item in optionsDocumentType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
                <div class="document-col">
                  <el-date-picker
                    v-model="doc.actionDate"
                    type="date"
                    placeholder="발행일 선택"
                    size="large"
                    style="width: 130px"
                    :clearable="false"
                    :disabled-date="disablePastDates"
                  />
                </div>
                <div class="document-col">
                  <el-select
                    v-model="doc.email"
                    placeholder="발행 이메일"
                    size="large"
                    style="width: 200px"
                  >
                    <el-option
                      v-for="item in options.optionsIssueEmail"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :class="{disabled: (disabledEmail === 'all' && item.value !== 'manager') || disabledEmail === item.value}"
                    />
                  </el-select>
                </div>
                <div class="document-col">
                <el-checkbox 
                  v-if="doc.periodic || (form.period && form.requestType === 'PLAN' && form.paymentCycle !== '0')"
                  v-model="doc.periodic"
                  label="주기별 발행"
                />
                <el-checkbox
                  v-if="doc.isEndOfMonth || (form.period && form.requestType === 'PLAN' && form.paymentCycle !== '0' && doc.periodic)"
                  :disabled="!isEndOfMonthEnabled(doc.actionDate)"
                  v-model="doc.isEndOfMonth"
                >
                  해당 월 마지막 날짜에 결제
                </el-checkbox>
              </div>
                <el-button
                  v-if="!(form.paymentType === 'wire' && doc.docType === 'TAX_INVOICE')"
                  type="primary"
                  text
                  round
                  aria-label="삭제"
                  @click="handleRemoveDocument(index)"
                >
                <font-awesome-icon icon="fa-regular fa-trash-can" />
              </el-button>
              </div>
              <el-button
                type="primary"
                plain
                @click="handleAddDocument"
              >
                <font-awesome-icon icon="fa-solid fa-plus" />
                추가
              </el-button>
            </el-form-item>
          </template>
        </section>
        <section class="section">
          <h3 class="tit-h3">
            메모
          </h3>
          <el-input
            v-model="form.memo"
            :rows="5"
            type="textarea"
            placeholder="입력하세요"
          />
        </section>
      </el-form>
      <div class="btn-group">
        <el-button
          type="primary"
          size="large"
          @click="handleSubmit"
        >
          저장
        </el-button>
        <el-button
          type="default"
          size="large"
          @click="toBack"
        >
          취소
        </el-button>
      </div>
    </template>
    <common-loader v-else />
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, defineProps, watch, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { RequestTypeKeys, optionsReqType, PaymentTypeKeys, DocumentTypeKeys, optionsDocumentType, PaymentCycleTypeKeys } from "@/types/constants";
import { disablePastDates } from '@/utils';
import * as options from '@/utils/options';
import { modifyRequest } from "@/api";
import { useRequestStore } from "@/stores/request";
import { ElMessage, ElMessageBox, ElInput, ElSelect } from 'element-plus'
import { usePlanStore } from "@/stores/plan";
import CommonLoader from '@/components/CommonLoader.vue';
import moment from "moment";

const router = useRouter();
const isLoading = ref<boolean>(false);
const requestStore = useRequestStore();

interface Document {
  docType: DocumentTypeKeys | undefined,
  actionDate: Date,
  email: 'tax' | 'manager' | 'system',
  periodic: boolean,
  isEndOfMonth: boolean
}

interface Form {
  customerId: string,
  requestType: RequestTypeKeys | undefined,
  beusPlanNumber: number | undefined,
  baPlanNumber: number | undefined,
  useStartDate: Date,
  period: string | undefined,
  useEndDate: Date | null,
  recurring: boolean | null,
  paymentType: PaymentTypeKeys,
  paymentCycle: PaymentCycleTypeKeys,
  amount: number,
  paymentDate: Date,
  isEndOfMonth: boolean,
  memo: string,
  docs: Document[]
}

const form = reactive<Form>({
  customerId: '',
  requestType: 'PLAN',
  beusPlanNumber: undefined,
  baPlanNumber: undefined,
  useStartDate: new Date(),
  period: undefined,
  useEndDate: null,
  recurring: false,
  paymentType: 'wire',
  paymentCycle: '0',
  amount: 0,
  paymentDate: new Date(),
  isEndOfMonth: false,
  memo: '',
  docs: []
})

const props = defineProps<{
  id: string;
}>();

const chargeType = ref<string>('charged')

const setPeriodEndDate = (start, period) => {
  const startYear = start.getFullYear();
  const startMonth = start.getMonth();
  const startDate = start.getDate();
  const periodNum = Number(period);
  if (startDate >= 29) return new Date(startYear, startMonth + periodNum + 1, 0);
  else return new Date(startYear, startMonth + periodNum, startDate - 1);
}

const findDocEmailType = (mails) => {
  if (mails === 'system') return 'system'
  const managerArr = requestStore.request?.customer.manager.map(em => em.mail).sort()

  return mails.sort() === managerArr ? 'manager' : 'tax'
}

const defaultEmail = ref('manager')
const disabledEmail = ref('all')

const fetchData = async () => {
  isLoading.value = true;

  try {
    // console.log(requestStore.request);
    const docs = requestStore.request?.payment.docs;
    const mapDocsToDocumentInputs = () => {
      if (!docs) return [];
      return docs.map((doc) => ({
        docType: doc.docType,
        actionDate: doc.actionDate ? new Date(doc.actionDate) : new Date,
        email:findDocEmailType(doc.email),
        periodic: doc.periodic,
        isEndOfMonth: doc.isEndOfMonth
      }));
    }

    const getFilteredDocuments = (docs: Document[]): Document[] => {
      if (!docs.length) return [];
      const groupedByDocType = docs.reduce<Record<string, Document[]>>((acc, doc) => {
        if (!doc.docType) return acc;
        acc[doc.docType] = acc[doc.docType] || [];
        acc[doc.docType].push(doc);
        return acc;
      }, {});
      return Object.values(groupedByDocType).flatMap((group) => {
        const firstPeriodicDoc = group.find((doc) => doc.periodic);
        const additionalDocs = group.filter(
          (doc) => group.length === 1 || !doc.periodic
        );
        return firstPeriodicDoc ? [firstPeriodicDoc, ...additionalDocs] : additionalDocs;
      });
    }

    Object.assign(form, {
      customerId: requestStore.request?.customer.customerId,
      requestType: requestStore.request?.detail.requestType,
      beusPlanNumber: requestStore.request?.detail.beusPlanNumber ?? -1,
      baPlanNumber: requestStore.request?.detail.baPlanNumber ?? -1,
      useStartDate: requestStore.request?.detail.useStartDate ? new Date(requestStore.request.detail.useStartDate) : new Date(),
      period: requestStore.request?.payment.period,
      useEndDate: requestStore.request?.detail.useEndDate ? new Date(requestStore.request.detail.useEndDate) : setPeriodEndDate(form.useStartDate, form.period),
      recurring: requestStore.request?.detail.recurring,
      paymentType: requestStore.request?.payment.paymentType,
      paymentCycle: requestStore.request?.payment.paymentCycle ? requestStore.request.payment.paymentCycle.toString() : '0',
      amount: requestStore.request?.payment.amount || 0,
      paymentDate: requestStore.request?.payment.paymentDate[0] ? new Date(requestStore.request?.payment.paymentDate[0]) : new Date(),
      memo: requestStore.request?.memo,
      docs: getFilteredDocuments(mapDocsToDocumentInputs(docs))
    });
    chargeType.value = form.paymentType === 'free' ? form.paymentType : 'charged'
    setEmailType(requestStore.request?.customer.taxInfo)

  } catch (error) {
    console.error('Error Message:', error);
    ElMessageBox.alert('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.<br/> 문제가 지속되면 관리자에게 문의하세요.', { 
      confirmButtonText: '확인',
      dangerouslyUseHTMLString: true
    });
  } finally {
    // console.log(form);
    isLoading.value = false;
  }
}

const setEmailType = (typeInfo) => {
  if (!typeInfo) {
    // documentInputs.value[0].email = 'manager'
    defaultEmail.value = 'manager'
    disabledEmail.value = 'all'
  } else if (typeInfo.taxInfoType === 'SYSTEM') {
    // documentInputs.value[0].email = 'system'
    defaultEmail.value = 'system',
    disabledEmail.value = 'tax'
  } else {
    // documentInputs.value[0].email = 'tax'
    defaultEmail.value = 'tax',
    disabledEmail.value = 'system'
  }
}

onMounted(() => {
  fetchData();
  form.docs.forEach((doc) => {
    if (doc.email === 'tax') {
      const hasTaxInfo = requestStore.request?.customer?.taxInfo
      doc.email = hasTaxInfo ? 'tax' : 'manager'
    }
  })
});

const toBack = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push('/');
  }
}

const planStore = usePlanStore();
// console.log('Beus', planStore.beusPlanData);
// console.log('Ba', planStore.baPlanData);
const planGroupLabels: Record<string, string> = {
  PAID: '일반',
  ENT: '엔터프라이즈',
  UNUSED: '미사용플랜',
};

const optionsPlan = computed(() => {
  const groupPlans = (planData: any[]) => {
    const grouped: Record<string, typeof planData> = {};
    for (const plan of planData) {
      const group = plan.planGroup || '';
      if (group === 'VOID') continue;
      if (!grouped[group]) grouped[group] = [];
      grouped[group].push(plan);
    }
    return Object.entries(grouped)
      .sort(([a], [b]) => {
        if (a === 'UNUSED') return 1;
        if (b === 'UNUSED') return -1;
        return 0;
      })
      .map(([planGroup, plans]) => ({
        planGroup: planGroupLabels[planGroup] ?? planGroup,
        plans,
      }));
  };

  return {
    beus: groupPlans(planStore.beusPlanData),
    ba: groupPlans(planStore.baPlanData)
  };
});

const updateRequestDatails = () => {
  const defaultValues = {
    PLAN: { beusPlanNumber: -1, baPlanNumber: -1, useStartDate: new Date(), period: '1', recurring: false },
    PV_CHARGE: { beusPlanNumber: undefined, baPlanNumber: undefined, useStartDate: new Date(), period: '1', recurring: false },
    JAM_CHARGE: { beusPlanNumber: undefined, baPlanNumber: undefined, useStartDate: new Date(), period: '60', recurring: false },
    ADDITIONAL: { beusPlanNumber:undefined, baPlanNumber: undefined, useStartDate: new Date(), period: undefined, recurring: null },
  };

  Object.assign(form, defaultValues[form.requestType] || {});
};

const dateRangeError = ref<boolean>(false)

watch(() => [form.useStartDate, form.period], () => {
  if (form.requestType === 'ADDITIONAL') {
    form.useEndDate = null
    dateRangeError.value = false
  } else {
    dateRangeError.value = form.useStartDate > form.useEndDate// form.useEndDate = setPeriodEndDate(form.useStartDate, form.period)
    
  }
}, { immediate: true });

const paymentCycleLabels: Record<string, string> = {
  "0": '일시납',
  "1": '월납',
  "2": '격월납',
  "3": '분기납',
  "4": '4개월납',
  "6": '반기납',
};

const optionsPaymentCycle = reactive<string[]>([]);

watch(() => form.period, (newVal) => {
  const period = Number(newVal);
  if (!isNaN(period) && period > 0) {
    optionsPaymentCycle.splice(0, optionsPaymentCycle.length, ...["0", "1", ...Object.keys(paymentCycleLabels)
      .filter(key => Number(key) > 1 && period % Number(key) === 0 && Number(key) !== period)]);

    if (!optionsPaymentCycle.includes(form.paymentCycle)) {
      form.paymentCycle = '0';
    }
  } else {
    optionsPaymentCycle.splice(0, optionsPaymentCycle.length);
    form.paymentCycle = '0';
  }
});

const isEndOfMonthEnabled = (date: Date): boolean => {
  const isLastDayOfMonth = (date: Date): boolean => {
    const nextDay = new Date(date);
    nextDay.setDate(date.getDate() + 1);
    return nextDay.getDate() === 1;
  }

  const month = date.getMonth() + 1; 
  const isLastDay = isLastDayOfMonth(date);

  return isLastDay && (month === 2 || [4, 6, 9, 11].includes(month));
}

const handleChargeType = () => {
  if (chargeType.value === 'charged') {
    form.paymentType = 'wire'
    handleChargePaymentType()
  } else {
    form.paymentType = 'free'
  }
}

const handleChargePaymentType = () => {

  form.docs = form.docs.filter((doc: Document) => doc.docType !== undefined);

  if (form.paymentType === 'wire') {
    const hasTaxInvoice = form.docs.some((doc:Document) => doc.docType === "TAX_INVOICE");

    if (!hasTaxInvoice) {
      form.docs.unshift({
        docType: 'TAX_INVOICE',
        actionDate: new Date(),
        email: defaultEmail.value,
        periodic: false,
        isEndOfMonth: false
      })
    }
  } else { 
    form.docs = form.docs.filter((doc: Document) => doc.docType !== "TAX_INVOICE");
  } 
};

const handleAddDocument = () => {
  form.docs.push({
    docType: undefined,
    actionDate: new Date(),
    email: defaultEmail.value,
    periodic: false,
    isEndOfMonth: false
  });
} 

const handleRemoveDocument = (index: number) => form.docs.splice(index, 1);

const handleSubmit = async () => {

  let formData = {
    requestId: props.id,
    requestType: form.requestType,
    baPlanNumber: form.baPlanNumber === -1 ? null : Number(form.baPlanNumber),
    beusPlanNumber: form.beusPlanNumber === -1 ? null : Number(form.beusPlanNumber),
    useStartDate: moment(form.useStartDate).format('YYYY-MM-DD'),
    useEndDate: form.useEndDate? moment(form.useEndDate).format('YYYY-MM-DD') : null,
    period: Number(form.period),
    recurring: form.recurring,
    paymentType: form.paymentType,
    isEndOfMonth: form.isEndOfMonth,
    memo: form.memo,
  }

  if (chargeType.value === 'charged') {
    const updatedDocumentInput = form.docs
    .filter((doc) => doc.docType !== undefined)
    .map((doc) =>  {
      return {
        ...doc,
        actionDate: moment(doc.actionDate).format('YYYY-MM-DD'), 
        email: doc.email === 'tax' ? requestStore.request?.customer.taxInfo?.taxInfoDetail : doc.email === 'manager' ? requestStore.request?.customer.manager.map(em => em.mail) : 'system',
        periodic: doc.periodic,
        isEndOfMonth: doc.isEndOfMonth
      }
    });

    formData = { ...formData,
      amount: Number(form.amount),
      paymentCycle: Number(form.paymentCycle),
      paymentDate: moment(form.paymentDate).format('YYYY-MM-DD'),
      docs: updatedDocumentInput
    }
  }
  try {
    // console.log(formData)
    if(validateFormData(formData)) {
      const response = await modifyRequest(formData);
      console.log('리퀘스트 수정 성공:', response);
      ElMessageBox.alert('리퀘스트를 수정했습니다.', {
        confirmButtonText: '확인',
        callback: () => {
          if (window.history.length > 1) {
            router.back();
          } else {
            router.push('/');
          }
        }
      });
    } else return;
  } catch (error) {
    console.error('Error Message:', error)
    ElMessage.error('리퀘스트 수정 실패했습니다. 다시 시도해주세요')
  }
};

type InputRef = {
  focus: () => void;
  value?: string | number;
};

const beusPlanInput = ref<InputRef>();
const periodInput = ref<InputRef>();
const amountInput = ref<InputRef>();

const validateFormData = (formData: Form) => {
  const showAlertAndFocus = (message: string, inputRef: InputRef | undefined) => {
    ElMessageBox.alert(message, { confirmButtonText: '확인' });
    if (inputRef && inputRef.focus) inputRef.focus();
    return false;
  };

  if (formData.requestType === 'PLAN' && formData.beusPlanNumber == null && formData.baPlanNumber == null) return showAlertAndFocus('플랜을 선택해주세요.', beusPlanInput.value);
  if (formData.requestType !== 'ADDITIONAL' && (isNaN(formData.period) || formData.period <= 0)) return showAlertAndFocus('계약 개월 수를 바르게 입력해주세요.', periodInput.value);
  if (chargeType.value === 'charged' && (isNaN(formData.amount) || formData.amount <= 0)) return showAlertAndFocus('금액을 바르게 입력해주세요.', amountInput.value);
  if (formData.requestType === 'PV_CHARGE' && dateRangeError.value) return showAlertAndFocus('사용 시작일이 사용 종료일 이후 입니다. 다시 입력하세요.')
  return true;
};

const setPlanDisabledDate = (date: Date) => {
  const start = new Date(form.useStartDate);
  const target = new Date(start.setDate(start.getDate() + 1))
  target.setHours(0, 0, 0, 0);
  return date < target;
}
</script>
